import PackageDeleteModal from './PackageDeleteModal';
export default PackageDeleteModal;
